import React from "react";

const PageOne = () => {
  return <h1>Page One</h1>;
};

export default PageOne;
